
/* injects from baggage-loader */

'use strict';

/**
 * custom files.
 */
import '!!file-loader?name=[name].[ext]!../favicon.ico';
import '!!file-loader?name=[name].[ext]!../.htaccess';

/**
 * images using in scss files.
 */
import '!!file-loader?name=assets/images/[name].[ext]!../assets/images/gana-background-login.jpg';

/**
 * Vendor files
 */
import "./index.vendor";

/**
 * Main App module
 */
import "./index.module";

/**
 * Main sass files
 */
import "../assets/styles/sass/index.scss";

angular.element(document).ready(() => {
  angular.bootstrap(document, ['raspagana'], {
    strictDi: true
  });
});



// WEBPACK FOOTER //
// ./src/app/index.bootstrap.js